import axios from 'axios'
import React from 'react'
import { toast } from 'react-toastify'
import { useAuth } from '../../providers/auth_provider';

export default function DeleteTemplate({ template, fetchTemplates }) {
    const { token } = useAuth();

    const deleteTemplate = async () => {
        try {
            const res = await axios.delete(`${process.env.REACT_APP_API_URL}/template/${template?.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`
                }
            });
            toast.success("Template deleted successfully");
            fetchTemplates();
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };

    return (
        <div className="modal fade" id="deleteTemplate" tabIndex={-1} aria-hidden="true">
            <div className="modal-dialog modal-simple modal-enable-otp modal-dialog-centered">
                <div className="modal-content">
                    <button
                        type="button"
                        id="closeDeleteModal"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    />
                    <div className="modal-body p-0">
                        <div className="text-center mb-6">
                            <h4 className="mb-2">Delete Template!</h4>
                            <i style={{ fontSize: '50px' }} className="ri-error-warning-line text-danger"></i>
                        </div>
                        <p className="mb-5 text-center">
                            Are you sure you want to delete this broadcast?
                        </p>
                        <div className="col-12 d-flex flex-wrap justify-content-center gap-4 row-gap-4">
                            <button onClick={deleteTemplate} data-bs-dismiss="modal" type="submit" className="btn btn-danger">
                                Delete Template
                            </button>
                            <button
                                type="reset"
                                aria-label="Close"
                                id="closeModal"
                                className="btn btn-outline-secondary"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
